import { useState, useCallback } from 'react';

import useApiRequest from 'hooks/useApiRequest';
import useAsync from 'hooks/useAsync';

interface RelatedSpace {
  id: number;
  name: string;
  image: Image;
  clinical: boolean;
  venue: Venue;
}

interface Venue {
  id: number;
  name: string;
}

interface Image {
  regular: string;
  thumbnail: string;
}

const useRelatedSpaces = (spaceId: number) => {
  const [relatedSpaces, setRelatedSpaces] = useState<RelatedSpace[]>([]);

  const apiRequest = useApiRequest();

  const fetchData = useCallback(async () => {
    const {
      data: { spaces },
    } = await apiRequest.get(`/v1/spaces/${spaceId}/related_spaces`);

    setRelatedSpaces(spaces);
  }, [apiRequest, spaceId]);

  const { loading, error } = useAsync(fetchData);

  return {
    data: relatedSpaces,
    loading,
    error,
  };
};

export default useRelatedSpaces;
